import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

export default Component('tr-selector-field-result', {
  mixins: [eventListenerMixin],

  properties: {
    selected: {
      type: Boolean,
      default: false,
      observer() {
        if (this.selectedChanged) this.selectedChanged();
      },
    },
  },

  ready() {
    this.selectedOption = null;
    this.nativeField = this.querySelector('.native-control-wrapper select');
    this.selectedText = this.querySelector('.selected-text');

    this.listenTo(this, 'click', () => this.namespacedTrigger('activeClick'));
  },

  disconnected() {
    this.stopListening();
  },

  selectOption(option) {
    if (!option) return false;

    this.selectedOption = option;
    this.selected = true;
    this.setSelectedOption(option);
    this.setSelectedResult(option);

    return true;
  },

  unselectOption(option) {
    if (!option) return false;

    this.selectedOption = null;
    this.selected = false;
    this.setSelectedOption(false);
    this.setSelectedResult(false);

    return true;
  },

  clearSelected() {
    this.unselectOption(this.selectedOption);
  },

  setSelectedResult(option) {
    if (option) {
      const result = [
        `<span class="text">${option.text}</span>`,
      ];

      if (option.data && option.data.avatar) {
        result.unshift(
          `<img src="${option.data.avatar}" class="avatar" alt="${option.text}">`,
        );
      } else if (option.data && option.data.icon) {
        result.unshift(`<i class="twr twr-${option.data.icon} icon"></i>`);
      }

      const { dataset } = this.selectedText;
      Object.keys(dataset).forEach(key => delete dataset[key]);

      Object.keys(option.data || {}).forEach((key) => {
        if (key !== 'avatar' && key !== 'icon' && key !== 'search-key') {
          this.selectedText.setAttribute(`data-${key}`, option.data[key]);
        }
      });

      this.selectedText.innerHTML = result.join('');
    } else {
      this.selectedText.getAttributeNames().forEach((attributeName) => {
        if (attributeName.startsWith('data-')) {
          this.selectedText.removeAttribute(attributeName);
        }
      });
      this.selectedText.innerHTML = '';
    }
  },

  setSelectedOption(option) {
    [...this.nativeField.selectedOptions].forEach((selectedOption) => {
      // eslint-disable-next-line no-param-reassign
      selectedOption.selected = false;
    });
    if (!option) return;

    const nativeOption = [...this.nativeField.options].find(opt => opt.value === option.value);
    if (nativeOption) {
      nativeOption.selected = true;
    } else {
      this.nativeField.appendChild(this.generateNativeOption(option));
    }
  },

  generateNativeOption(option) {
    const nativeOption = document.createElement('option');
    nativeOption.value = option.value;
    nativeOption.textContent = option.text;
    nativeOption.selected = true;
    return nativeOption;
  },
});
